import React, { useDispatch, useSelector } from 'react';
import { getStroke, getColor } from '../color';
import StarIcon from '../../HOME/SVG/StarIcon';
import { PN_BLUE, PN_GREEN, PN_YELLOW, PN_INDIGO, PN_RED, PN_PURPLE } from '../../PN/const';
import { MODE_FRIEND } from '../../HOME/const';

const Tile = ({ style = {}, props, width, tile, color, off, hint, starColors }) => {
  const dispatch = useDispatch();
  const { selected } = useSelector(state => state.pt);

  if (tile) {
    const { row, col, home } = tile;
    off = Math.abs(home.row - row) + Math.abs(home.col - col);
    color = getColor(off, props);

    if (!off && !tile.player) {
      tile.player = 1;
    }

    if (tile.player) {
      starColors = ['cyan', PN_BLUE];

      if (tile.player === 2) {
        if (props.mode === MODE_FRIEND) {
          starColors = ['hotpink', PN_PURPLE];
        } else {
          switch (props.skill) {
            case 1:
              starColors = ['lime', PN_GREEN];
              break;
            case 2:
              starColors = ['yellow', PN_YELLOW];
              break;
            case 3:
              starColors = ['violet', PN_INDIGO];
              break;
            case 4:
              starColors = ['red', 'darkred'];
              break;
            default:
          }
        }
      }
    }
  }

  const stroke = getStroke(color);

  const handleClick = () => {};

  return (
    <div style={{ display: 'grid', boxShadow: '0.1em 0.1em 0.1em black', ...style, zIndex: `${selected ? 1 : 0}` }} onClick={handleClick}>
      <svg style={{ display: 'block', gridArea: '1/1' }} width={width} height={width} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <g>
          <rect width="100" height="100" fill={color} stroke="white" strokeWidth={selected ? 16 : 4} />
          {hint && <circle cx="50" cy="50" r="30" stroke={stroke} strokeWidth="4" fill="none" />}
          {off && (
            <text fill={stroke} x={off < 10 ? 51 : 49} y="61" textAnchor="middle" fontSize="32" fontFamily="Roboto Mono">
              {off}
            </text>
          )}
        </g>
      </svg>
      {!off && (
        <StarIcon
          style={{ gridArea: '1/1', alignSelf: 'center', justifySelf: 'center' }}
          width={width * 0.5}
          rounded
          color={starColors && starColors[0]}
          color2={starColors && starColors[1]}
        />
      )}
    </div>
  );
};

export default Tile;
